import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { EventEmitter2 } from 'eventemitter2';
import { LRUMap } from 'lru_map';
export var PREVIEW_CACHE_LRU_SIZE = 50;
var ExtendedLRUCache = /*#__PURE__*/function (_LRUMap) {
  function ExtendedLRUCache(limit) {
    var _this;
    _classCallCheck(this, ExtendedLRUCache);
    _this = _callSuper(this, ExtendedLRUCache, [limit]);
    _this.eventEmitter = new EventEmitter2();
    return _this;
  }
  _inherits(ExtendedLRUCache, _LRUMap);
  return _createClass(ExtendedLRUCache, [{
    key: "shift",
    value: function shift() {
      var entry = _superPropGet(ExtendedLRUCache, "shift", this, 3)([]);
      this.eventEmitter.emit('shift', entry);
      return entry;
    }
  }, {
    key: "on",
    value: function on(event, callback) {
      this.eventEmitter.on(event, callback);
    }
  }]);
}(LRUMap);
export var ObjectURLCache = /*#__PURE__*/function () {
  function ObjectURLCache(size) {
    _classCallCheck(this, ObjectURLCache);
    this.cache = new ExtendedLRUCache(size);
    this.cache.on('shift', function (entry) {
      if (entry && entry[1].dataURI) {
        URL.revokeObjectURL(entry[1].dataURI);
      }
    });
  }
  return _createClass(ObjectURLCache, [{
    key: "has",
    value: function has(key) {
      return !!this.cache.find(key);
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.cache.get(key);
    }
  }, {
    key: "set",
    value: function set(key, value) {
      this.cache.set(key, value);
    }
  }, {
    key: "remove",
    value: function remove(key) {
      var removed = this.cache.delete(key);
      removed && URL.revokeObjectURL(removed.dataURI);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.cache.clear();
    }
  }]);
}();
export var createObjectURLCache = function createObjectURLCache() {
  return new ObjectURLCache(PREVIEW_CACHE_LRU_SIZE);
};